import { CanActivateFn, Router } from '@angular/router';
import { iif, mergeMap, of, tap } from 'rxjs';
import { inject } from '@angular/core';

import { ToastService } from '@app/services/toast.service';
import { UserService } from '@app/services/user.service';
import { APP_ROUTES } from '@app/app-routes.const';

export const PartnerGuard: CanActivateFn = (route, state) => {
  const toastSrv = inject(ToastService);
  const userSrv = inject(UserService);
  const router = inject(Router);

  return userSrv.isLoggedIn$.pipe(
    mergeMap((isAuthenticated) =>
      iif(
        () => isAuthenticated,
        userSrv.isPartnerOrAdmin$.pipe(
          tap((hasPermission) => {
            if (!hasPermission) {
              toastSrv.showToast('Forbidden! You do not have permission to access this page');
            }
          }),
        ),
        of(
          router.createUrlTree([APP_ROUTES.LOGIN], {
            queryParams: {
              returnUrl: state.url,
            },
          }),
        ),
      ),
    ),
  );
};
